<template>
    <div class="p-md">
        <div class="app-block p-md">
            <h3 class="heading-line title is-4 has-text-weight-light"><span
                :style="'color: '+school">Cursus Académique</span>
            </h3>
            <div class="tile is-ancestor">
                <div class="tile is-parent">
                    <div class="tile is-child">
                        <div class="" v-if="cursus.baccalaureate === 'yes'">
                            <h3 v-if="cursus.baccalaureate_series !== 'Autre'">
                                <strong>Bac {{ cursus.baccalaureate_series
                                    }} obtenu en {{ cursus.baccalaureate_year }}</strong></h3>
                            <h3 v-else><strong><i>Bac {{ cursus.baccalaureate_other
                                }} obtenu en {{ cursus.baccalaureate_year }}</i></strong></h3>
                        </div>
                        <div class="" v-else-if="cursus.baccalaureate === 'current'">
                            <h3 v-if="cursus.baccalaureate_series !== 'Autre'">
                                <strong>Bac {{ cursus.baccalaureate_series
                                    }} en cours d'obtention</strong></h3>
                            <h3 v-else><strong><i>Bac {{ cursus.baccalaureate_other }} en cours d'obtention</i></strong>
                            </h3>
                        </div>

                        <div class="" v-if="cursus.current_grade">
                            <div class="current-grade">Classe actuelle: <strong>{{ cursus.current_grade }}</strong>
                            </div>
                        </div>

                        <div class='timeline m-r-md' v-if='anyDegree()'>
                            <div v-for='degree in orderedDegrees' class="timeline-item" :date-is='degree.year'>
                                <h3 class="degree-name">{{ degree.name }}</h3>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="tile is-4 is-vertical is-parent">
                    <div class="tile is-child">

                        <h3 v-if="cursus.lv1 || cursus.lv2 || cursus.lv3"><strong>Langues</strong></h3>
                        <p v-if="cursus.lv1">{{ cursus.lv1 }}</p>
                        <p v-if="cursus.lv2">{{ cursus.lv2 }}</p>
                        <p v-if="cursus.lv3">{{ cursus.lv3 }}</p>
                    </div>
                </div>

            </div>

            <div class="has-text-right">
                <button class="button" @click="edit" v-if="!registered">Modifier
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                cursus: {}
            }
        },
        props: {
            school: {type: String},
            candidate: { type: Object },
            curriculum: { type: Object }
        },
        computed: {
            ...mapGetters({
                application: 'candidate/getSingleApplication'
            }),
            registered () {
                return this.application.registration && this.application.registration.registered_candidate
            },
            orderedDegrees: function () {
                return _.orderBy(this.cursus.degrees, 'year')
            }
        },
        methods: {
            edit: function () {
                this.$emit('edit')
            },
            anyDegree () {
                return !_.isEmpty(this.candidate.curriculum.degrees)
            }
        },
        created: function () {
            this.cursus = this.candidate.curriculum
        }

    }
</script>

<style lang="scss" scope>

    .timeline-item::before {

    }

    $border-color: rgba(#0f1e44, .3);

    .timeline-item {
        padding: 2em 2.5em 0.1em;
        position: relative;
        color: rgba(black, .7);
        border-left: 2px solid $border-color;

        .degree-name {
            font-size: 1.2rem;
        }

        &::before {
            content: attr(date-is);
            position: absolute;
            left: 2em;
            font-weight: bold;
            top: 1em;
            display: block;
            font-weight: 700;
            font-size: 0.8rem;
        }

        &::after {
            width: 10px;
            height: 10px;
            display: block;
            top: 1.4em;
            position: absolute;
            left: -6px;
            border-radius: 10px;
            content: '';
            border: 2px solid $border-color;
            background: white;
        }

        &:last-child {
            border-image: linear-gradient(
                            to bottom,
                            $border-color 60%,
                            rgba($border-color, 0)) 1 100%;
        }
    }

</style>
